import { render, staticRenderFns } from "./PageUserAccount.vue?vue&type=template&id=20ae24b4&"
import script from "./PageUserAccount.js?vue&type=script&lang=js&"
export * from "./PageUserAccount.js?vue&type=script&lang=js&"
import style0 from "./PageUserAccount.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports